import type { ButtonHTMLAttributes } from 'react';

import './button.css';

type Variant = 'primary' | 'ghost' | 'icon';

export function Button(
  { variant = 'ghost', className = '', ...rest }:
  ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant },
) {
  return <button type="button" className={`btn btn--${variant} ${className}`} {...rest} />;
}
